import React from 'react';
import styled, { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { createTheme } from '../utils/createTheme';
/**
 * @public
 */
export const Base = /*#__PURE__*/styled.div.withConfig({
  displayName: "ThemeProvider__Base",
  componentId: "sc-1502h3l-0"
})(["font-family:", ";line-height:", ";font-weight:", ";*{box-sizing:border-box;}"], props => props.theme.font, props => props.theme.lineHeights.standard, props => props.theme.fontWeights.medium);
/**
 * @public
 */
export const ThemeProvider = ({
  theme,
  customBreakpoints,
  ...props
}) => {
  // Once updated to React 16.8 this should be wrapped in React.useMemo()
  const mergedTheme = existingTheme => createTheme(theme, customBreakpoints, existingTheme);
  return React.createElement(StyledThemeProvider, {
    theme: mergedTheme
  }, React.createElement(Base, {
    ...props
  }));
};